<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg"  :style="{backgroundImage: detailParam.banner}">
            </div>
            <div class="container">
                <div class="page-header__inner" >
                        <h1>
                             <!-- {{ detailParam.title }} -->
                            {{ $t(`solution.${detailParam.i18n_title}`) }}
                        </h1>
                        <div class="page-header__inner_text">
                             <!-- {{ detailParam.text }} -->
                                {{ $t(`solution.${detailParam.i18n_text}`) }}
                        </div>
                </div>
            </div>
        </section>
	    <!-- 横向导航 -->
        <div id="nav-wrapper" class="nav-wrapper">
            <!--横向导航栏-->
            <ul>
                <li><a data-tab="#plan_overview"  class="active"> 
                    <!-- 方案概况  -->
                    {{ $t('solution.solution_nav_overview') }}    
                </a></li>
                <li><a data-tab="#plan_build" > 
                    <!-- 方案架构  -->
                     {{ $t('solution.solution_nav_architecture') }}
                </a></li>
                <li><a data-tab="#plan_solve" > 
                     <!-- 解决方案场景  -->
                    {{ $t('solution.solution_nav_scene') }}
                </a></li>
            </ul>
            <div class="clearfix"></div>
        </div>
        <!-- 方案概况 -->
        <section id="plan_overview" class="we-help" style="padding: 80px 0;background-color: #f9fafc;">
            <div class="container">
                
                <h2 class="container_title" >
                    <!-- 方案概况 -->
                    {{ $t('solution.solution_overview_title') }}
                </h2>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 text_margin" style="    text-indent: 32px;">
                       <p> 
                         <!-- {{ detailParam.summarize }}  -->
                        {{ $t(`solution.${detailParam.i18n_summarize}`) }}
                       </p>
                    </div>
                   
                </div>
            </div>
        </section>
        <!-- 方案架构 -->
        <section id="plan_build" style="padding: 80px 0;background-color: #ffffff;">
            <div class="container">
                <h2 class="container_title"  >
                      <!-- 方案架构 -->
                      {{ $t('solution.solution_architecture_title') }}
                </h2>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 text_margin " >
                        <img class="row_img" :src="detailParam.architecture" />
                    </div>
                </div>
            </div>

        </section>
        <!-- 解决方案 -->
        <section id="plan_solve" style="padding: 80px 0;background-color: #f9fafc;">
            <div class="container" style="background-color: #f9fafc; max-width: 1400px;">
                <h2 class="container_title" >
                    <!-- 解决方案场景 -->
                     {{ $t('solution.solution_scene_title') }}
                </h2>
                <div class="row text_margin margin_bottom">
                    <div class="col-xl-12 col-lg-12 text_margin scene_nav" >
                        <a v-for="(item, index) in detailParam.i18n_sceneList" 
                            :key="index" 
                            class="scene_nav_item" 
                            :class="item.type == sceneType ? 'scene_nav_act' : ''"
                            @click="handkeSwitch(item)"
                        >
                            <p>
                                 <!-- {{ item.title }}  -->
                                {{ $t(`solution.${item.title}`) }}
                            </p>
                        </a>
                    </div>
                </div>
                <div  v-for="(item, index) in detailParam.i18n_sceneList" :key="index"  >
                    <div class="row text_margin"  v-if="item.type == sceneType">
                        <div class="col-xl-6 col-lg-12 wow fadeInUp" >
                            <img  class="row_img" style="border-radius: 6px;" :src="item.sceneImg" />
                        </div>
                        <div class="col-xl-6 col-lg-12 wow fadeInUp " >
                            <h3 class="scene_title">
                                 <!-- {{ item.introduceTitle }} -->
                                {{ $t(`solution.${item.introduceTitle}`) }}
                            </h3>
                            <div class="scene_text text_margin_buttom">
                            <p  v-for="(tdItem,tdIndex) in item.introduceList" :key="tdIndex">
                                <!-- {{ tdItem }} -->
                                {{ $t(`solution.${tdItem}`) }}
                            </p>
                            </div>
                            <h3 class="scene_title">
                                <!-- {{ item.meritTltle }} -->
                                {{ $t(`solution.${item.meritTltle}`) }}
                            </h3>
                            <div style="display: flex; margin-bottom: 15px; font-size: 16px" v-for="(tdItem,tdIndex) in item.meritList" :key="tdIndex">
                                <div class="icon" style="color: var(--notech-base);font-size: 16px; line-height: 1.5;">
										<span class="icon-check"></span>
									</div>
									<div class="text" style="margin-left: 10px; color: var(--notech-black); line-height: 1.5;">
										<p>
                                            <!-- {{ tdItem }} -->
                                             {{ $t(`solution.${tdItem}`) }}
                                        </p>
									</div>
                            </div>
                            <div class="scene_img" v-if="item.meritImg">
                                <img  :src="item.meritImg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 客户案例 -->
        <section id="plan_custom" class="contact-details" v-if="detailParam.customList.length">
            <div class="container">
                <h2 class="container_title">
                    客户案例
                </h2>
                <div class="row text_margin">
                    <div class="col-xl-3 col-lg-12 wow fadeInUp custom_item" v-for="(item,index) in detailParam.customList" :key="index" @click="handleRouter(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <img class="row_img" :src="item.img"  alt="">
                    </div> 
                </div>       
            </div>
        </section>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'mbSolutionDeatil',
    mixins: [MixinsList],
    data () {
        return {
            detailParam: {},
            sceneType: "",
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
        // $('.nav-wrapper a').click(function() {
		// 	// $('.nav-wrapper a').removeClass('active');
        //     $('.active').removeClass('active');
		// 	$(this).addClass('active');
		// 	$("html, body").animate({
		// 		// scrollTop: $($(this).attr("href")).offset().top - 62 + "px"
        //         scrollTop: $($(this).attr("data-tab")).offset().top - 55 + "px"
		// 	}, 1);
		// });

		// var navTop = $('.nav-wrapper').offset().top;
		// $(window).scroll(function() {
		// 	if ($(window).scrollTop() > navTop) {
		// 		$('.nav-wrapper').addClass('nav-wrapper_fixed');
		// 		$('.main-header').css("position", "relative");
		// 	} else {
		// 		$('.nav-wrapper').removeClass('nav-wrapper_fixed');
		// 		$('.main-header').css("position", "fixed");
		// 	}
		// });
    },
    beforeDestroy() {
        $(window).unbind('scroll')
    },
    methods: {
           // 初始化横向导航的 jQuery 逻辑
        initNavWrapper() {
            $('.nav-wrapper a').click(function() {
			// $('.nav-wrapper a').removeClass('active');
            $('.active').removeClass('active');
			$(this).addClass('active');
			$("html, body").animate({
				// scrollTop: $($(this).attr("href")).offset().top - 62 + "px"
                scrollTop: $($(this).attr("data-tab")).offset().top - 55 + "px"
			}, 1);
		});

            var navTop = $('.nav-wrapper').offset().top;
            $(window).scroll(function() {
                if ($(window).scrollTop() > navTop) {
                    $('.nav-wrapper').addClass('nav-wrapper_fixed');
                    $('.main-header').css("position", "relative");
                } else {
                    $('.nav-wrapper').removeClass('nav-wrapper_fixed');
                    $('.main-header').css("position", "fixed");
                }
            });
        },
        // 获取内容
        async getList() {
            // const { result } = res
            
            // // this.detailParam = JSON.parse(JSON.stringify(result.programmeList.pressureVessel))  
            // this.detailParam = result.programmeList[this.$route.query.type]
            // this.sceneType = this.detailParam.i18n_sceneList[0].type

            //  if(this.$i18n.locale == 'zh_CN') {
            //     this.detailParam.i18n_architecture = this.detailParam.architecture  // 客户案例图片
            // } else if(this.$i18n.locale == 'en_US') {
            //    this.detailParam.i18n_architecture = this.detailParam.architecture_en  // 客户案例图片
            // }else if(this.$i18n.locale == 'ru_RU') {

            // }

            try {
                const  result = await loadData('solutionDetail', this.lang)
                this.detailParam = result.programmeList[this.$route.query.type]
                this.sceneType = this.detailParam.i18n_sceneList[0].type

            } catch (error) {
                console.log(error)
                this.detailParam= {}
            }
             // 数据就绪后初始化导航（v-if 变为 true，DOM 已渲染）
            this.$nextTick(() => {
                this.initNavWrapper();
            });

        },
        // 应用场景切换
        handkeSwitch(item) {
            this.sceneType = item.type
        },
        // 路由跳转
        handleRouter(val) {
            this.$router.push({
                path: val
            });
        },
      
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent;  
}

.page-header__inner h1{
    text-align: center;
    font-size: var(--font-size-20) !important;
 }
 

.page-header__inner_text{
    width: 100%;
    font-size: 16px;
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }

 .main-slider .container {
    padding-top: 120px;
    padding-bottom: 120px;
}

.nav-wrapper ul {
    padding: 15px;
    list-style-type: none;
    width: 100%;
    margin: auto;
    text-align: center;
}
.nav-wrapper li {
    width: 33%;
    margin-right: 0;
}

.nav-wrapper li a {
    font-size: 16px;
    display: block;
    color: var(--notech-black);
    text-align: center;
    line-height: 50px;
    height: 50px;
    text-decoration: none;
}
.nav-wrapper li a:hover {
    color: #097cf2;
    border-bottom: solid 2px #097cf2;
}


.row_img {
    max-width: 100%;
}

.scene_img {
    width: 100%;
    height: 240px;
}
.scene_img img {
    max-width: 100%;
    max-height: 100%;
}
/* 面包屑 */
/* ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
} */
.carousel__item {
    width: 100%;
    text-align: center;

}
.carousel__item_img {
    max-width: 100%;
    height: 100%;
}







.container_title {
    width: 100%;
    text-align: center;
    line-height: 60px;
    font-size: var(--font-size-30);
    font-weight: bold;
    color: #232e5e;
}
.text_margin {
    margin-top: 20px;
    color: #666666;
    font-size: 16px;
}

.sceneImg_item {
    display: none;
    transition: opacity 500ms ease 0s;
}
.sceneImg_show{
    display: block;
    transition: opacity 500ms ease 0s;
}
.scene_nav{
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.scene_nav_item {
    cursor: pointer;
    width: 33%;
    text-align: center;
    font-weight: 400;
    font-size: 10px;
    color: #4e5969;
}
/* .scene_nav_item:hover p{
    width: 100%;
    margin: 0 auto;
    background: var(--notech-base);
    color: #ffffff;
    transition: all 0.36s;
    border-radius: 6px;
} */
.scene_nav_act p{
    width: 100%;
    margin: 0 auto;
    background: var(--notech-base);
    color: #ffffff;
    transition: all 0.36s;
    border-radius: 6px;
}
.scene_title {
    margin-top: 20px;
    font-size: var(--font-size-20);
    font-weight: bold;
    margin-bottom: 20px;
}
.scene_text {
    font-size: 16px;
    line-height: 30px;
}
.text_margin_buttom {
    margin-bottom: 30px;
}

.custom_item {
    cursor: pointer;    
    padding: 10px;
    text-align: center;
    box-shadow: 0px 5px 52px 0 rgba(19, 55, 159, 0.08)
}
.margin_bottom {
    margin-bottom: 60px;
}
</style> 
